import React, { use, useEffect, useState } from "react";

import { Row } from "antd";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";

import UIText from "./UIText";
import UIButton from "./UIButton";
import SignUpPopup from "../../common/SignInPopup";
import { getUserInfo } from "../../../common/userfuctions";

const Heading = dynamic(() => import("./UIHeading.js"));

const UISuccessMessage = ({
  message,
  secondMessage,
  inModal,
  showLogin,
  postAJobBtnTitle,
  postAJobBtnClick,
  backbtn,
  gotohomeBtn,
  type,
  image,
  access
}) => {
  const [showSignup, setShowSignup] = useState(false);
  const router = useRouter();
  const user = getUserInfo();


  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const onMyJobsClick = () => {
    router.push("/myjobs");
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
      }}
    >
      <img
        src={image || `https://cdn.hireside.com/cdn/images/Characters/Success1.svg`}
        alt="No Data"
        width={280}
      />
      <br />
      <br />
      <Heading style={{ textAlign: "center" }} level={inModal ? 4 : 2}>
        {message}
      </Heading>

      {
        !user &&
        <UIText style={{ fontSize: 22 }} type="secondary">
        {secondMessage}
      </UIText>
      }

      <Row style={{ marginTop: 40 }}>
        {user && type && type === "applyJob" ? (
          <UIButton onClick={onMyJobsClick}>My Jobs</UIButton>
        ) : null}
        {postAJobBtnTitle && (
          <UIButton onClick={postAJobBtnClick}>{postAJobBtnTitle}</UIButton>
        )}
        {backbtn && (
          <UIButton
            style={{ marginLeft: 10 }}
            onClick={() => router.back()}
            type="secondary"
          >
            Explore More Opportunities
          </UIButton>
        )}
        {gotohomeBtn && (
          <UIButton
            style={{ marginLeft: 10 }}
            onClick={() => router.push("/employer/home")}
            type="secondary"
          >
            Return to home
          </UIButton>
        )}
        {!user && showLogin ? (
          <UIButton
            onClick={() => setShowSignup(!showSignup)}
            style={{ marginLeft: 10 }}
            type="primary"
          >
            Login
          </UIButton>
        ) : null}
      </Row>
      <SignUpPopup
        visible={showSignup}
        openNewTab={true}
        onClose={() => setShowSignup(false)}
      />
    </div>
  );
};

export default React.memo(UISuccessMessage);
